// ── 계약완료 목록 배경색 필터 — 공용 ColorSwatchFilter 위임 ──────────────────────
//   공개 API(active, onToggle) 유지. 스와치 렌더는 components/ColorSwatchFilter 공용.
import React from 'react';
import { ColorSwatchFilter } from '../../../components/ColorSwatchFilter';
import { CONTRACT_COLOR_FILTERS } from './rowState';

export function ContractColorFilter({ active, onToggle }) {
  return <ColorSwatchFilter filters={CONTRACT_COLOR_FILTERS} active={active} onToggle={onToggle} />;
}
